export const woonenergieTextLinkTokens = {
  // High emphasis variant
  textLinkHighEmphasisDefaultTextColor: '{{ linkColors.linkBrand }}',
  textLinkHighEmphasisHoverTextColor: '{{ linkColors.linkBrand }}',
  textLinkHighEmphasisFocusTextColor: '{{ linkColors.linkBrand }}',
  textLinkHighEmphasisDefaultUnderlineColor: '{{ linkColors.linkBrand }}',
  textLinkHighEmphasisHoverUnderlineColor: '{{ linkColors.linkBrand }}',
  textLinkHighEmphasisFocusUnderlineColor: '{{ linkColors.linkBrand }}',
};
